import Axios from 'axios';
import { API_ROOT } from '../config';

const ax = Axios.create({
	baseURL: API_ROOT['osbod_salary'],
	timeout: 120000
});

function buildQuery(params) {
	var query = {};
	if (!params) {
		return query;
	}
	Object.keys(params).forEach(function (key) {
		var value = params[key];
		if (value !== undefined && value !== null && value !== '') {
			query[key] = value;
		}
	});
	return query;
}

function revokeLater(url) {
	setTimeout(function () {
		try {
			URL.revokeObjectURL(url);
		} catch (e) {
			/* ignore */
		}
	}, 60000);
}

async function fetchPdfBlob(reportCode, params) {
	try {
		var response = await ax.get('/report/' + encodeURIComponent(reportCode) + '/pdf', {
			params: buildQuery(params),
			responseType: 'blob'
		});
		return response.data;
	} catch (error) {
		var message = 'Report request failed';
		var status = error && error.response ? error.response.status : null;
		var data = error && error.response ? error.response.data : null;
		if (data) {
			try {
				var text =
					typeof data.text === 'function' ? await data.text() : String(data);
				var body = JSON.parse(text);
				if (body && body.error) {
					message = body.error;
				}
			} catch (e) {
				/* keep default message */
			}
		} else if (error && error.message) {
			message = error.message;
		}
		var err = new Error(message);
		err.status = status;
		throw err;
	}
}

/**
 * Open a registered Jasper report PDF in a new browser tab.
 * @param {string} reportCode
 * @param {object} params approved report parameters only (no SQL)
 */
export async function openPdf(reportCode, params) {
	var blob = await fetchPdfBlob(reportCode, Object.assign({}, params, { disposition: 'inline' }));
	var url = URL.createObjectURL(blob);
	window.open(url, '_blank');
	revokeLater(url);
	return true;
}

/**
 * Download a registered Jasper report PDF.
 * @param {string} reportCode
 * @param {object} params
 * @param {string} [filename]
 */
export async function downloadPdf(reportCode, params, filename) {
	var blob = await fetchPdfBlob(
		reportCode,
		Object.assign({}, params, { disposition: 'attachment' })
	);
	var url = URL.createObjectURL(blob);
	var link = document.createElement('a');
	link.href = url;
	link.download = filename || reportCode + '.pdf';
	document.body.appendChild(link);
	link.click();
	document.body.removeChild(link);
	revokeLater(url);
	return true;
}

export default {
	openPdf: openPdf,
	downloadPdf: downloadPdf
};
